import useExclusion from '@/composables/exclusion';
import useRepo from '@/nebula/repo';
import { goal as goalConfig } from 'shared/api/query/configs.json';
import { useGoalExclusionCheck } from '@/composables/goal/goal-exclusion-check';

export default function useGoalsRepo() {
  const repo = useRepo(goalConfig.model);
  const { shouldExclude } = useGoalExclusionCheck();
  const exclusion = useExclusion(repo, goalConfig.model, shouldExclude);

  const query = (queries, options = { excludeLoaded: false }) => {
    let modifiedQueries = queries;
    if (options.excludeLoaded === true) {
      modifiedQueries = exclusion.applyExclusion(queries);
    }

    return repo.query(modifiedQueries, options);
  };

  return {
    ...repo,

    query,
  };
}
